export const getChartPreviewBackup = async (
	baseCurrencyId: string,
	quoteCurrency: string,
	from: number | string,
	to: number | string,
	interval: string,
) => {
	try {
		const availableQuoteCurrencyList = {
			eur: 'eur',
			eth: 'ethereum',
			btc: 'bitcoin',
			usd: 'usd',
		};
		const res = await fetch(
			`/api/coin-data/chart-preview/backup?base=${baseCurrencyId}&quote=${availableQuoteCurrencyList[quoteCurrency]}&from=${from}&to=${to}&interval=${interval}`,
		);
		const sparklines = await res.json();

		return sparklines;
	} catch (error) {
		console.log('error occurred', error);
	}
};
